import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { Formik } from "formik";
import pick from "lodash/pick";
import React from "react";
import { NotesFormContent } from "./NotesFormContent";
import { NoteFields } from "./types";
export var NotesForm = function NotesForm(_ref) {
  var _ref$noteFields = _ref.noteFields,
      noteFields = _ref$noteFields === void 0 ? Object.values(NoteFields) : _ref$noteFields,
      notes = _ref.notes,
      submit = _ref.handleSubmit,
      formId = _ref.formId,
      props = _objectWithoutProperties(_ref, ["noteFields", "notes", "handleSubmit", "formId"]);

  var notesWithPickedFields = {};

  if (notes) {
    notesWithPickedFields = pick(notes, noteFields);
  }

  return React.createElement(Formik, {
    initialValues: notesWithPickedFields,
    enableReinitialize: true,
    onSubmit: function onSubmit(newValues, _ref2) {
      var setSubmitting = _ref2.setSubmitting;

      if (submit) {
        submit(newValues);
      }

      setSubmitting(false);
    }
  }, function (_ref3) {
    var handleChange = _ref3.handleChange,
        handleSubmit = _ref3.handleSubmit,
        handleBlur = _ref3.handleBlur,
        values = _ref3.values,
        setFieldValue = _ref3.setFieldValue,
        setFieldTouched = _ref3.setFieldTouched;
    return React.createElement(NotesFormContent, _extends({
      formId: formId,
      handleBlur: handleBlur,
      handleChange: handleChange,
      handleSubmit: handleSubmit,
      noteFields: noteFields,
      setFieldTouched: setFieldTouched,
      setFieldValue: setFieldValue,
      values: values
    }, props));
  });
};